<template>
  <section class="py-9 tablet:py-20">
    <div class="container-wrap-max-1792">
      <div
        class="relative overflow-hidden rounded-3xl bg-cover bg-center before:absolute before:inset-0 before:bg-[linear-gradient(180deg,theme(colors.brand.700/25%)_75.94%,theme(colors.brand.700/50%)_100%),linear-gradient(84deg,theme(colors.brand.700)_0%,theme(colors.cyan.400\_a2)_80%,theme(colors.brand.400)_100%)] before:content-['']"
        :style="{ backgroundImage: `url(${thumbnail})` }"
      >
        <div
          class="container-wrap relative flex min-h-[480px] flex-col justify-center p-4 tablet:p-6 desktop:flex-row desktop:items-center desktop:p-8"
        >
          <div class="mb-6 desktop:mb-0 desktop:w-8/12 desktop:pr-3">
            <h2
              class="text-h1 mb-6 text-center text-white tablet:mb-5 tablet:line-clamp-2 desktop:text-left"
            >
              {{ title }}
            </h2>
            <TheRichText
              v-if="!isMobile && (descriptionHtml || description)"
              class="tablet:line-clamp-7 mb-5 text-center text-base text-white desktop:text-left desktop:text-lg"
              :text="descriptionHtml || description"
              :is-html="!!descriptionHtml"
            />
          </div>
          <div class="desktop:w-4/12 desktop:pl-3">
            <div class="flex flex-wrap justify-center">
              <TheButton
                v-if="button01?.text"
                :id="button01?.trackingCode"
                :to="button01.link"
                :title="button01.text"
                type="outline"
                class="mb-4 w-full !border-white last:mb-0 tablet:mb-0 tablet:mr-2.5 tablet:w-72 desktop:mb-3 desktop:w-full"
              >
                <span class="font-bold">
                  {{ button01.text }}
                </span>
              </TheButton>
              <TheButton
                v-if="button02?.text"
                :id="button02?.trackingCode"
                :to="button02.link"
                :title="button02.text"
                type="outline"
                class="mb-4 w-full !border-white !bg-transparent !text-white last:mb-0 tablet:mb-0 tablet:mr-2.5 tablet:w-72 desktop:mb-3 desktop:w-full"
              >
                <span class="font-bold">
                  {{ button02.text }}
                </span>
              </TheButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=12717-62373&t=fmEJ8XqQ7lUX5VEy-0
   */

  interface IButton {
    text: string;
    link: string;
    trackingCode?: string;
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    thumbnail: string;
    button01?: IButton;
    button02?: IButton;
    theme?: TTheme;
  }

  withDefaults(defineProps<IProps>(), {
    description: undefined,
    descriptionHtml: undefined,
    button01: undefined,
    button02: undefined,
    theme: 'blue',
  });

  const { isMobile } = useScreen();

  export type { IButton };
</script>
